import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import DocsSaudeLogged from '../../../../components/auth/saude/documentos'

function DocsSaudeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Documentos da Secretaria Municipal de Saúde" />
                <HeaderLogged />
                <Container>
                   <DocsSaudeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default DocsSaudeLoggedScreen;